import React from 'react';

interface BadgeProps {
  text: string;
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'secondary' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  text,
  variant = 'primary',
  size = 'sm',
  className = '',
}) => {
  // Get variant class
  const getVariantClass = () => {
    switch(variant) {
      case 'primary':
        return 'badge-primary';
      case 'success':
        return 'badge-success';
      case 'warning':
        return 'badge-warning';
      case 'danger':
        return 'badge-danger';
      case 'secondary':
        return 'badge-secondary';
      case 'info':
        return 'badge-info';
      default:
        return 'badge-primary';
    }
  };

  // Get size class
  const getSizeClass = () => {
    switch(size) {
      case 'sm':
        return 'badge-sm';
      case 'md':
        return 'badge-md';
      case 'lg':
        return 'badge-lg';
      default:
        return 'badge-sm';
    }
  };

  const variantClass = getVariantClass();
  const sizeClass = getSizeClass();

  return (
    <span
      className={`badge ${variantClass} ${sizeClass} ${className}`}
    >
      {text}
    </span>
  );
};

export default Badge;
